export default __webpack_public_path__ + "static/badge-color-dark-f300bf45edd91900a64c49cb81f33dcaca71fc2754cd3fba7e28bf5ffd907b7d.png";